import { getCreditApplicationCustomerStipulations } from '../../../services/api/miles/miles-credit-services';
import {
  MilesCreditApplicationStipulationStatus,
  MilesStipulationTypeDefinitionId,
} from '../../../types/dashboardDocuments';

type SolvencyStatus = CreditIntegration.Schemas.SolvencyCheck['status'];

const statusesEligibleForCheckId: Array<SolvencyStatus> = [
  'STUDY_AUTO',
  'STUDY',
  'ACCEPTATION_CONDITIONAL',
  'ACCEPTED_WITH_RESERVATION_AUTO',
  'ACCEPTED_DEFINITIVE_AUTO',
  'COMPLETED',
  'KO_TECHNIQUE',
];

export const shouldCheckIdStipulationStatus = (status: SolvencyStatus) => statusesEligibleForCheckId.includes(status);

export const isIdCardStipulationStatusDefined = async (
  creditApplicationId: string,
  quoteId: string
): Promise<boolean> => {
  try {
    const receivedStipulations = await getCreditApplicationCustomerStipulations(quoteId, creditApplicationId);
    const idCheckStipulation = receivedStipulations.documents.find(
      (stipulation) => stipulation.stipulationTypeDefinitionId === MilesStipulationTypeDefinitionId.ID_CARD_APPLICANT
    );
    const stipulationStatus = idCheckStipulation?.stipulationStatus?.toUpperCase();

    if (
      stipulationStatus === MilesCreditApplicationStipulationStatus.CREATED ||
      stipulationStatus === MilesCreditApplicationStipulationStatus.REFUSED
    ) {
      return true;
    }
  } catch (error) {
    return false;
  }

  return false;
};
